import * as Types from '@typings/graphql-models';
import { Id } from './common';

type Price = {
  id: Id;
  createdAt: string;
  bookingCalendarLink: string | null;
  originalPrice?: number | null;
  sessionDuration?: number | null;
  sessionInterval?: number | null;
  currency: Types.Currency;
  isMostPopular?: boolean | null;
  product: {
    id: Id;
    image: {
      url: string;
    }
    creator: {
      slug: string;
    }
    title: string;
    slug: string;
    state: Types.ProductState;
    productTypes: { noodleProductType?: Types.NoodleProductTypes | null }[];
  };
  price: number;
  trialPeriodDays: number;
  usageType: Types.StripePriceUsageType;
  recurringInterval?: Types.Interval | null;
  stripePriceId?: string | null;
  priceSubDescription?: string | null;
  priceTitle?: string | null;
  isActive?: boolean;
  numBookings?: number;
};

export const RECURRING_INTERVALS_ABBREVIATED = {
  DAY: 'dy',
  MONTH: 'mo',
  SIXMONTHS: '6 mo\'s',
  THREEMONTHS: '3 mo\'s',
  WEEK: 'wk',
  YEAR: 'yr',
};

export default Price;
